import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 270px;
  margin-top: 185px;

  .brand {
    margin-top: 11px;
    color: ${colors.white};
    .rook {
      font-size: 33px;
      font-weight: bold;
    }

    .hotel {
      font-size: 33px;
      font-weight: 300;
    }
  }

  .infoContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;

    .title {
      color: ${colors.lightBlue};
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 24px;
    }

    .title.warning {
      color: ${colors.red};
    }

    .description {
      width: 280px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      color: ${colors.white};
    }

    .highlight {
      margin-top: 16px;
      font-size: 16px;
      color: ${colors.lightBlue};
      text-decoration: underline;
      cursor: pointer;
      margin-left: 5px;
    }

    .setupPassword {
      position: relative;
      width: 100%;

      .passwordLock,
      .passwordUnlock {
        position: absolute;
        top: 55px;
        right: 12px;
        cursor: pointer;
      }
    }
  }
`;